(() => {
  angular
    .module('app.settings')
    .factory('DcmNotification', DcmNotification)
    .controller('DcmNotificationController', DcmNotificationController);

  function DcmNotification() {
    const alert = this;
    alert.visible = false;
    alert.show = () => alert.visible = true;
    alert.hide = () => alert.visible = false;

    return alert;
  }

  DcmNotificationController.$inject = [
    '$http',
    '$scope',
    '$window',
    '$interval',
    '$location',
    'DcmNotification',
  ];

  function DcmNotificationController(
    $http,
    $scope,
    $window,
    $interval,
    $location,
    DcmNotification,
  ) {
    const vm = this;
    const pathApi = '/api/dcm';

    vm.gotoEdit = () => {
      const url = $location.absUrl();
      const path = url.includes('/settings/') ? '' : '/settings'
      $location.path(`${path}/apiintegrations`);

      if (path) {
        $window.location.href = $location.absUrl();
      }
    };

    $scope.$watch(() => DcmNotification.visible,
      visible => vm.show = visible);

    const fetchIntegrations = () => {
      $http.get(`${pathApi}/integrations`)
        .then(({ data }) => {
          if (data && data.some(item => item.status === 'Failed')) {
            DcmNotification.show();
          } else {
            DcmNotification.hide();
          }
        })
    };
    fetchIntegrations();

    $interval(() => {
      fetchIntegrations();
    }, 5 * 60 * 1000);
  }
})();
